/**
 * User API service
 * Handles user-related endpoints
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { USER, ME } from '../../constants';
import { User } from '../../types';
import { ServiceResult } from '../../types/common/api.types';

export interface UserWithLocale {
  user: User;
  locale?: string;
}

export class UserApiService extends BaseApiService {
  async getCurrentUser(): Promise<ServiceResult<UserWithLocale>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<User> = await this.api.get(`${USER}${ME}`);

      // Extract Content-Language header if present
      // Check both lowercase and capitalized versions
      const contentLanguage =
        response.headers['content-language'] ||
        response.headers['Content-Language'] ||
        response.headers['CONTENT-LANGUAGE'];

      return {
        user: response.data,
        locale: contentLanguage || undefined,
      };
    });
  }
}
